export const doctorNameAndId = `
  id
  name {
    firstFull
    last
    title
  }
`;

export const doctorBaseData = `
  id
  deletedAt
  name {
    firstFull
    last
    gender
    title
  }
  subjectArea
  phoneNumber
  fax
  houseDoctor
  city
  zipCode
  houseNumber
  mobilePhoneNumber
  street
  email
  praxis
  nursingHomeId
`;
